import { get } from 'lodash';
import { CreativeBasic, parseCreativeValue } from 'core/creative/Creative';
import { RichMediaTemplatePreview } from 'components/RichMediaPreview/RichMediaTemplatePreview';
import styles from './richMediaCreativeDetail.module.scss';

export const RichMediaCreativeDetail: React.FC<{ creative: Partial<CreativeBasic> }> = (props) => {
  const creativeValue = parseCreativeValue(props.creative);
  // 後端可能回 null，_.get 的預設值只在 undefined 時生效，故額外用 || 收斂。
  const marqueeImages = (get(creativeValue, 'marqueeImages') || []).map((marqueeImage: any) => ({
    url: get(marqueeImage, 'imageUrl')
  }));
  return (
    <RichMediaTemplatePreview
      className={styles.richMediaCreativeDetailContainer}
      templateId={get(creativeValue, 'templateId')}
      barImage={{ url: get(creativeValue, 'barImage.imageUrl') }}
      expandImage={{ url: get(creativeValue, 'expandImage.imageUrl') }}
      expandVideo={{ url: get(creativeValue, 'expandVideo.videoUrl') }}
      marqueeImages={marqueeImages}
      landingPage={get(props.creative, 'bannerUrl')}
    />
  );
};
